module.exports = __webpack_public_path__ + "img/download_bk.a5d23a5e.png";